import SideNavigation, { SideNavigationProps } from "@amzn/awsui-components-react-v3/polaris/side-navigation";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
// TODO: bring back the component
// import BreadcrumbGroup from '@amzn/awsui-components-react/polaris/breadcrumb-group';

const HOME = { text: "SWO", href: "#/" };
const items: SideNavigationProps.Item[] = [{ type: "link", text: "Home", href: "#/" }];

// Class ServiceNavigation is the Side Navigation component that is used in BasicLayout, CreateForm, ServiceHomepage, and Table flows.
// Implement like this: <ServiceNavigation />
class ServiceNavigationLocal extends React.Component<RouteComponentProps> {
  // If the provided link is empty, do not redirect pages
  onFollowHandler(event: CustomEvent<SideNavigationProps.FollowDetail>) {
    event.preventDefault();
    this.props.history.push(event.detail.href.substring(1));
  }

  render() {
    return (
      <SideNavigation
        header={HOME}
        items={items}
        activeHref={`#${this.props.location.pathname}`}
        onFollow={this.onFollowHandler.bind(this)}
      />
    );
  }
}

export const ServiceNavigation = withRouter(ServiceNavigationLocal);
